import {Component, computed, inject, input, model, signal} from '@angular/core';
import {CommonModule, formatNumber} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {toSignal} from '@angular/core/rxjs-interop';
import {InputNumberModule} from 'primeng/inputnumber';
import {InputTextModule} from 'primeng/inputtext';
import {TranslocoPipe, TranslocoService} from '@jsverse/transloco';
import {DirectusTooltipComponent} from '../../../directus-tooltip/directus-tooltip.component';

@Component({
  selector: 'app-model-field-percentage',
  imports: [
    CommonModule,
    FormsModule,
    InputNumberModule,
    InputTextModule,
    TranslocoPipe,
    DirectusTooltipComponent,
  ],
  templateUrl: './model-field-percentage.component.html',
  styleUrl: './model-field-percentage.component.scss',
})
export class ModelFieldPercentageComponent {
  id = input.required<string>();
  label = input<string>('');
  tooltipKey = input<string>('');
  placeholder = input<string>('');
  isReadOnly = input<boolean>(false);
  smallLabel = input<boolean>(false);
  minFractionDigits = input<number>(0);
  maxFractionDigits = input<number>(2);
  locale = input<string>('');

  isRequired = input<boolean>(false);

  private readonly translocoService = inject(TranslocoService);

  private readonly activeLang = toSignal(this.translocoService.langChanges$, {
    initialValue: this.translocoService.getActiveLang(),
  });

  readonly effectiveLocale = computed(() => this.locale() || this.activeLang());

  value = model<number | null>(null);

  protected readonly isTouched = signal<boolean>(false);

  readonly isInvalid = computed(() => {
    if (!this.isRequired() || !this.isTouched()) return false;
    const v = this.value();
    return v === null || v === undefined;
  });

  readonly formattedReadOnlyValue = computed(() => {
    const val = this.value();
    if (val === null || val === undefined) return '';
    return `${formatNumber(
      val,
      this.effectiveLocale(),
      `1.${this.minFractionDigits()}-${this.maxFractionDigits()}`,
    )}%`;
  });

  protected markAsTouched(): void {
    this.isTouched.set(true);
  }
}
